import React from "react";

export default function Attachments(props) {
    return (
        <ul className="attachments">
            {props.attachments.map((attachment, index) => {
                return (
                    <li key={index}>
                        <a
                            className="attachmentName"
                            href={attachment.url}
                            target="_blank"
                            title="Klicka för att öppna filen"
                        >
                            {attachment.name}
                        </a>
                        {props.isEditable && (
                            <button
                                className="attachmentRemove btn btn-sm"
                                onClick={event =>
                                    props.removeAttachment(event, attachment)
                                }
                                title="Klicka för att ta bort länken"
                            >
                                &times;
                            </button>
                        )}
                    </li>
                );
            })}
        </ul>
    );
}
